module.exports = __webpack_public_path__ + "static/media/skill1_neg_es.8c1a56a3.txt";